module.exports = new __parcel__URL__("user-divider.cbebe2f3.svg").toString();